import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { logoutUser } from "actions/user";
import { redirect } from "actions/navigation";

import constants from "constants";
import routePaths from "../../Router/routePaths";
import { Space, Typography } from "antd";

const { Title, Paragraph } = Typography;
import accessDeniedImage from "images/access-denied.gif";

import Button from "widgets/Button";
import styles from "./index.scss";
import PropTypes from 'prop-types';

const AccessDenied = ({ forceLogout = true }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.userInfo.isLoggedIn);

  useEffect(() => {
    forceLogout && isLoggedIn && dispatch(logoutUser());
  }, []);

  return (
    <section
      className={styles.root}
      style={{
        height: forceLogout ? '100vh' : 'auto',
      }}
    >
      <div className={styles.left}>
        <img
          className={styles.image}
          src={accessDeniedImage}
          alt="accessDenied"
        />
      </div>
      <div className={styles.right}>
        <Title>Access Denied</Title>
        {forceLogout && (
          <>
            <Paragraph>
              Sorry, this site is only available for internal upGrad users.
            </Paragraph>
            <Paragraph>
              Login to the website using upGrad credentials or contact{' '}
              <a href={'mailto:techsupport@upgrad.com'}>upGrad Tech Support</a>
            </Paragraph>
            <Space className={styles.action}>
              <Button
                type="dashed"
                onClick={() => dispatch(redirect(routePaths.loginPage))}
              >
                Go Back to Login
              </Button>
              <Button
                type="primary"
                onClick={() =>
                  (window.location = constants.marketingPlatformURL)
                }
              >
                Continue on upGrad.com
              </Button>
            </Space>
          </>
        )}
      </div>
    </section>
  );
};

AccessDenied.defaultProps = {
  forceLogout: true,
};

AccessDenied.propTypes = {
  forceLogout: PropTypes.bool,
};
export default AccessDenied;
